import { ChevronRight } from "lucide-react";
import { Mono } from "@/components/site/primitives";
import { cn } from "@/lib/utils";

export const StageRail = ({ stages, sel, onSelect, testid, loopLabel, renderMeta }) => (
  <div className="border-b border-o-line px-4 py-5 sm:px-6 sm:py-6">
    <ol className="grid gap-2 sm:grid-cols-5">
      {stages.map((s, i) => {
        const on = sel === s.id;
        return (
          <li key={s.id} className="relative">
            <button type="button" onClick={() => onSelect(s.id)} aria-pressed={on} data-testid={`${testid}-stage-${s.id}`}
              className={cn("flex h-full w-full items-start gap-4 border p-3 text-left transition-colors sm:flex-col sm:gap-5 sm:p-4",
                on ? "border-o-accent bg-o-soft" : "border-o-line bg-o-bg hover:border-o-strong")}>
              <Mono accent={on}>{s.index}</Mono>
              <span>
                <span className="block font-display text-base font-bold leading-tight sm:text-lg">{s.label}</span>
                {renderMeta && renderMeta(s)}
              </span>
            </button>
            {i < stages.length - 1 && (
              <ChevronRight aria-hidden className="absolute -right-[12px] top-1/2 z-10 hidden h-4 w-4 -translate-y-1/2 text-o-dim sm:block" />
            )}
          </li>
        );
      })}
    </ol>
    {loopLabel && (
      <div className="mt-2">
        <div aria-hidden className="mx-[10%] hidden h-5 border-x border-b border-dashed border-o-strong sm:block" />
        <p className="mt-2 sm:text-center"><Mono>{loopLabel}</Mono></p>
      </div>
    )}
  </div>
);

export const StageStepper = ({ ids, sel, onSelect, testid }) => {
  const i = ids.indexOf(sel);
  const btn = "font-mono text-[11px] uppercase tracking-[0.16em] text-o-dim transition-colors hover:text-o-text disabled:opacity-30 disabled:hover:text-o-dim";
  return (
    <div className="flex items-center justify-between border-t border-o-line px-5 py-3 sm:px-6">
      <button type="button" disabled={i === 0} onClick={() => onSelect(ids[i - 1])} data-testid={`${testid}-prev`} className={btn}>← Previous</button>
      <Mono>Stage {i + 1} of {ids.length}</Mono>
      <button type="button" disabled={i === ids.length - 1} onClick={() => onSelect(ids[i + 1])} data-testid={`${testid}-next`} className={btn}>Next →</button>
    </div>
  );
};
